<div class="hb-container hb-container--width-lg">
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--12of12 hb-cell--3of12@md">
      <stat-filter (selectedFilters)="filterVisning($event)" seksjon="startlan"></stat-filter>
    </div>
    <div class="hb-cell hb-cell--12of12 hb-cell--9of12@md">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Startlån</h1>
      <hb-accordion class="hb-mb--lg">
        <hb-accordion-element id="startlaanID">
          <h2 title class="hb-accordion-tittel">Om startlån</h2>
          @if (valgtFilter?.["Låneordning"]?.includes("Ordinært startlån")) {
            <div body="">
              <p><b>Ordinært startlån</b></p>
              <p>
                Ordinært startlån er for personer som over tid ikke får boliglån i privat bank. Det kan gjøres unntak fra kravet om langvarige boligfinansieringsproblemer, for
                eksempel hvis husstanden har barn, eller det foreligger særlige sosiale eller helsemessige utfordringer.
              </p>
              <p></p>
              <p>Startlån kan også gis til:</p>
              <ul class="hb-list hb-list--gap-none hb-text--xs">
                <li><b>refinansiering,</b>dersom søker står i fare for å miste boligen</li>
                <li><b>utbedring eller tilpasning</b>av bolig, for eksempel ved nedsatt funksjonsevne</li>
              </ul>
              <p>Ordinært startlån skiller seg fra det forsøksordningen ved følgende betingelser:</p>
              <table class="hb-table--simple custom-tabell-klasse">
                <tr>
                  <th scope="col">Kriterium</th>
                  <th scope="col">Forsøksordning</th>
                  <th scope="col">Ordinær ordning</th>
                </tr>
                <tr>
                  <td scope="row">Avslag i privat bank</td>
                  <td scope="row">Ja</td>
                  <td scope="row">Ja</td>
                </tr>
                <tr>
                  <td scope="row">Egenkapital</td>
                  <td scope="row">Minimum 5 %</td>
                  <td scope="row">Vurdering av sparepotensial</td>
                </tr>
                <tr>
                  <td scope="row">Løpetid</td>
                  <td scope="row">30 år</td>
                  <td scope="row">Opptil 50 år</td>
                </tr>
                <tr>
                  <td scope="row">Lånets varighet</td>
                  <td scope="row">Inntil 10 år</td>
                  <td scope="row">Opptil 50 år</td>
                </tr>
                <tr>
                  <td scope="row">Boligtilskudd</td>
                  <td scope="row">Ja/td></td>
                  <td scope="row">Ja</td>
                </tr>
                <tr>
                  <td scope="row">Refinansiering</td>
                  <td scope="row">Ikke mulig</td>
                  <td scope="row">Ja</td>
                </tr>
                <tr>
                  <td scope="row">Rentebetingelser</td>
                  <td scope="row">Markedsrente - 0,75 %</td>
                  <td scope="row">Markedsrente – 0,75 %</td>
                </tr>
              </table>
              <p>Kommunen behandler søknadene og vurderer om husstanden oppfyller vilkårene.</p>
              <p><b>Tall i statistikkbanken</b> er periodisert etter:</p>
              <ul class="hb-list hb-list--gap-none hb-text--xs">
                <li>når søknaden er mottatt,</li>
                <li>når utbetaling er foretatt, og</li>
                <li>når avslag er gitt.</li>
              </ul>
              <p>
                Statistikken for forsøksordningen viser antall søknader, utbetalinger og avslag per periode. Søknader, utbetalinger og avslag kan gjelde ulike år, og kan derfor
                ikke summeres direkte.
              </p>
              <p>
                <b>For mer informasjon om startlånsordningen:</b>
                <a href="https://husbanken.no/startlaan/" class="hb-button hb-button--link" target="_blank">
                  <span class="hb-button-text">Om startlån</span>
                  <span class="hb-icon hb-button-icon" aria-hidden="true">
                    <svg focusable="false">
                      <use xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                    </svg>
                  </span>
                </a>
              </p>
            </div>
          } @else if (valgtFilter?.["Låneordning"]?.includes("Startlån til førstegangs etablere")) {
            <div body="">
              <p><b>Startlån – forsøksordning for førstegangsetablerere</b></p>
              <p>
                Startlån i forsøksordningen er for personer som står uten mulighet til å få lån i privat bank, men som er noe bedre økonomisk stilt enn de som vanligvis får
                ordinært startlån. Ordningen er etablert for å bidra til at flere får mulighet til å eie egen bolig.
              </p>
              <p></p>
              <p>Søknadsbehandling og vedtak skjer i kommunen, som vurderer om husstanden fyller kriteriene for forsøksordningen./p></p>
              <p>Forsøksordningen skiller seg fra det ordinære startlånet ved følgende betingelser:</p>
              <table class="hb-table--simple custom-tabell-klasse">
                <tr>
                  <th scope="col">Kriterium</th>
                  <th scope="col">Forsøksordning</th>
                  <th scope="col">Ordinær ordning</th>
                </tr>
                <tr>
                  <td scope="row">Avslag i privat bank</td>
                  <td scope="row">Ja</td>
                  <td scope="row">Ja</td>
                </tr>
                <tr>
                  <td scope="row">Krav til egenkapital</td>
                  <td scope="row">Minimum 5 %</td>
                  <td scope="row">Vurdering av sparepotensial</td>
                </tr>
                <tr>
                  <td scope="row">Maks løpetid</td>
                  <td scope="row">30 år</td>
                  <td scope="row">Opptil 50 år</td>
                </tr>
                <tr>
                  <td scope="row">Lånets varighet</td>
                  <td scope="row">Inntil 10 år</td>
                  <td scope="row">Opptil 50 år</td>
                </tr>
                <tr>
                  <td scope="row">Boligtilskudd</td>
                  <td scope="row">Ja/td></td>
                  <td scope="row">Ja</td>
                </tr>
                <tr>
                  <td scope="row">Refinansiering</td>
                  <td scope="row">Ja</td>
                  <td scope="row">Ikke mulig</td>
                </tr>
                <tr>
                  <td scope="row">Rente</td>
                  <td scope="row">Markedsrente minus 0,75 %</td>
                  <td scope="row">Markedsrente minus 0,75 %</td>
                </tr>
              </table>
              <p>Kommunen behandler søknadene og vurderer om husstanden oppfyller vilkårene.</p>
              <p><b>Tall i statistikkbanken</b> er periodisert etter:</p>
              <ul class="hb-list hb-list--gap-none hb-text--xs">
                <li>når søknaden er mottatt,</li>
                <li>når utbetaling er foretatt, og</li>
                <li>når avslag er gitt.</li>
              </ul>
              <p>
                Statistikken for forsøksordningen viser antall søknader, utbetalinger og avslag per periode. Søknader, utbetalinger og avslag kan gjelde ulike år, og kan derfor
                ikke summeres direkte.
              </p>
              <p>
                <b>For mer informasjon om startlånsordningen:</b>
                <a href="https://husbanken.no/startlaan/" class="hb-button hb-button--link" target="_blank">
                  <span class="hb-button-text">Om startlån</span>
                  <span class="hb-icon hb-button-icon" aria-hidden="true">
                    <svg focusable="false">
                      <use xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                    </svg>
                  </span>
                </a>
              </p>
            </div>
          } @else {
            <div body="">
              <p><b>Startlån</b></p>
              <p>
                Startlån i forsøksordningen er for personer som står uten mulighet til å få lån i privat bank, men som er noe bedre økonomisk stilt enn de som vanligvis får
                ordinært startlån. Ordningen er etablert for å bidra til at flere får mulighet til å eie egen bolig.
              </p>
              <p></p>
              <p>Søknadsbehandling og vedtak skjer i kommunen, som vurderer om husstanden fyller kriteriene for forsøksordningen.</p>
              <ul class="hb-feltliste"></ul>
            </div>
          }
        </hb-accordion-element>
      </hb-accordion>
      <fieldset class="hb-felt">
        <legend class="hb-screenreader-only">Sorter etter</legend>
        <div class="hb-buttongroup">
          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandSoknad" type="radio" (click)="filterTilstand('Søknad')" />
          <label class="hb-button hb-button--standard" for="typeTilstandSoknad">Søknad</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandUtbetaling" type="radio" checked="" (click)="filterTilstand('Utbetaling')" />
          <label class="hb-button hb-button--standard" for="typeTilstandUtbetaling">Utbetaling</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandAvslag" type="radio" (click)="filterTilstand('Avslag')" />
          <label class="hb-button hb-button--standard" for="typeTilstandAvslag">Avslag</label>
        </div>
      </fieldset>

      @if (statistikkType === "Søknad") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForSoknad" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }
      @if (statistikkType === "Utbetaling") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForUtbetaling" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }
      @if (statistikkType === "Avslag") {
        <div class="hb-grid">
          <stat-kpitabell [kpiIder]="kpiListeForAvslag" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
        </div>
      }

      <div class="hb-grid">
        <div class="hb-fieldset hb-cell hb-cell--12of12">
          <div class="hb-legend">
            <div class="hb-legend-tekst" aria-hidden="true" id="hva-du-vil-se">Velg hva du vil se:</div>
            <hb-hjelpetekst labelledby="hva-du-vil-se">
              @for (item of objectKeys(typeTekst[statistikkType]); track item) {
                <div>
                  <p class="hb-avstand--ingen">
                    <strong>{{ typeTekst[statistikkType][item][0] }}:</strong>
                  </p>
                  <p class="hb-avstand--avsnitt">{{ typeTekst[statistikkType][item][1] }}</p>
                </div>
              }
            </hb-hjelpetekst>
          </div>
          <fieldset class="hb-felt">
            <legend class="hb-screenreader-only">Velg hva du vil se:</legend>
            <ul class="hb-feltliste hb-feltliste--horisontal">
              @for (value of objectKeys(typeTekst[statistikkType]); track value) {
                <li>
                  <input
                    (change)="selectedRadio($event)"
                    class="hb-radiobutton"
                    [id]="value"
                    type="radio"
                    name="radio1"
                    [value]="value"
                    [checked]="statistikkType === 'Avslag' || (statistikkType === 'Søknad' && graferValgt === 'belop') ? value === 'soknader' : value === graferValgt"
                  />
                  <div class="hb-label">
                    <label class="hb-label-tekst" [for]="value">
                      <span>{{ typeTekst[statistikkType][value][0] }}</span>
                    </label>
                  </div>
                </li>
              }
            </ul>
          </fieldset>
          <stat-kommunefilter></stat-kommunefilter>
        </div>
      </div>

      @if (graferValgt === "soknader" && statistikkType !== "Avslag") {
        <div class="hb-grid">
          @for (soknadId of grafIderForSoknad; track soknadId) {
            <stat-qlik-graf
              id="{{ soknadId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "belop" && statistikkType === "Søknad") {
        <div class="hb-grid">
          @for (soknadIdB of grafIderForSoknad; track soknadIdB) {
            <stat-qlik-graf
              id="{{ soknadIdB }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "belop" && statistikkType === "Utbetaling") {
        <div class="hb-grid">
          @for (belopId of grafIderForBelop; track belopId) {
            <stat-qlik-graf
              id="{{ belopId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "gjennomsnitt" && statistikkType !== "Avslag") {
        <div class="hb-grid">
          @for (gjsnittId of grafIderForGjennomsnitt; track gjsnittId) {
            <stat-qlik-graf
              id="{{ gjsnittId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "vedtak" && statistikkType === "Avslag") {
        <div class="hb-grid">
          @for (avslagId of grafIderForAvslag; track avslagId) {
            <stat-qlik-graf
              id="{{ avslagId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }

      @if (graferValgt === "soknader" && statistikkType === "Avslag") {
        <div class="hb-grid">
          @for (avslagId of grafIderForAvslagSaker; track avslagId) {
            <stat-qlik-graf
              id="{{ avslagId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
    </div>
  </div>
</div>
